var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "54px",
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "446D2560-0422-4D31-A88D-04E883E95075") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "013_pago_noefectuado",
    transform: "translate(-693.000000, -193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(693.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5959",
    x: 0,
    y: 0,
    width: 54,
    height: 54,
    rx: 27
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(14.000000, 14.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3230447,-1.70782105 L13.6769553,-1.70782105 C15.3338095,-1.70782105 16.6769553,-0.364675298 16.6769553,1.29217895 L16.6769553,24.707821 C16.6769553,26.3646753 15.3338095,27.707821 13.6769553,27.707821 L12.3230447,27.707821 C10.6661905,27.707821 9.32304474,26.3646753 9.32304474,24.707821 L9.32304474,1.29217895 C9.32304474,-0.364675298 10.6661905,-1.70782105 12.3230447,-1.70782105 Z",
    id: "Rectangle",
    transform: "translate(13.000000, 13.000000) rotate(-45.000000) translate(-13.000000, -13.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3230447,-1.70782105 L13.6769553,-1.70782105 C15.3338095,-1.70782105 16.6769553,-0.364675298 16.6769553,1.29217895 L16.6769553,24.707821 C16.6769553,26.3646753 15.3338095,27.707821 13.6769553,27.707821 L12.3230447,27.707821 C10.6661905,27.707821 9.32304474,26.3646753 9.32304474,24.707821 L9.32304474,1.29217895 C9.32304474,-0.364675298 10.6661905,-1.70782105 12.3230447,-1.70782105 Z",
    id: "Rectangle",
    transform: "translate(13.000000, 13.000000) rotate(-315.000000) translate(-13.000000, -13.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group5.89e05d2209242f41214988cfba55988a.svg";
export { ForwardRef as ReactComponent };